import { fetcher } from "helpers/fetcher";

import { TUpdateProfilePictureReq, TUpdateProfilePictureRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const updateProfilePicture = async (
  payload: TUpdateProfilePictureReq
) => {
  return await fetcher<
    TUpdateProfilePictureRes,
    TUpdateProfilePictureReq["data"]
  >(ENDPOINT.USER.UPDATE_PROFILE_PICTURE, {
    data: payload.data,
    fileFields: ["image"],
    headers: {
      [API_HEADER.VERSION]: ENDPOINT.USER.UPDATE_PROFILE_PICTURE.version,
      [API_HEADER.USER_ID]: payload.idUser,
    },
  });
};

export const mutationUpdateProfilePicture = async (
  payload: TUpdateProfilePictureReq
) => {
  return (await updateProfilePicture(payload)).data;
};

mutationUpdateProfilePicture._key = (payload: TUpdateProfilePictureReq) => [
  ENDPOINT.USER.UPDATE_PROFILE_PICTURE.url,
  payload,
];
